import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";
import { getInitialLocale } from "./i18n";

const savedCartItem = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

const savedFavouritesItem = localStorage.getItem("favouritesItems")
  ? JSON.parse(localStorage.getItem("favouritesItems"))
  : [];

const initialState = {
  cart: savedCartItem,
  locale: { lang: getInitialLocale() },
  favourites: savedFavouritesItem,
};

const middleware = [thunk];

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
